import { getFeatureFlagValue, getRemoteConfig } from '@libs/abby/abby';

export const getLowercaseLocale = (locale: string): string => {
  const normalized = locale.toLowerCase();
  return normalized.length === 2 ? `${normalized}-de` : normalized;
};

/**
 * Determines if the new header is enabled for a given locale using feature flags and remote config.
 *
 * TODO: Remove when new header is fully rolled out.
 */
export const isNewHeaderEnabled = (locale: string): boolean => {
  if (!getFeatureFlagValue('useNewHeader')) {
    return false;
  }

  const config = getRemoteConfig<'showNewHeaderLocalesConfig', 'String'>('showNewHeaderLocalesConfig');

  return config === 'all' || config?.split(',').includes(locale) || false;
};
